import React from 'react';
import FinanceService from "../images/finance.svg";
import { Link } from 'react-router-dom';
import SubServiceSectionFinance from '../components/SubServiceSectionFinance';


const ConsultancyServices = () => {
  return (
    <div className = "relative">
    <img
      className="h-auto w-full object-cover"
      src={FinanceService}
      alt="Finance Service"
    />
    {/* <div className="absolute top-48 left-4 p-4 bg-opacity-75 bg-black text-white">
      <h1 className="text-2xl sm:text-4xl font-semibold">Marketing Services</h1>
    </div> */}

    <div>

    <section className='text-left mt-6'>
    <h1 className="text-center my-6 text-2xl font-semibold">Finance Services</h1>
      {/* <h1 className="text-xl font-semibold m-6 text-[#13689b]">Our Managed IT Services ensure a smooth transition and ongoing optimization with a three-step process:</h1> */}
      <p className="text-md text-black px-12 text-justify">
      WhyMe Solutions provides comprehensive finance services that ensure your financial operations are managed effectively and strategically. Our solutions help you maintain financial health, comply with regulations, and make informed business decisions. Moreover, our comprehensive range of finance services is designed to support businesses in managing their finances effectively, ensuring compliance, and driving growth. We offer expert financial planning, analysis, and advisory services tailored to your specific needs, helping you navigate the complexities of financial operations with confidence.
      </p>
      {/* <div className="border border-1 border-[#13689b] mt-4 mx-4"></div> */}
    </section>

    {/* <WeProvideSection /> */}
   

    <section>
      {/* <h2 className="text-xl font-semibold mb-6">Explore our Managed IT Services</h2>
      <p className="text-md text-gray-700 mb-6 px-12">
      Discover our range of Managed IT Services designed to keep your business running smoothly and efficiently. From immediate technical support to collaborative IT management and proactive network administration, our expert team is here to ensure your technology infrastructure is robust and reliable. Learn more about how our services can help you achieve your business goals.
      </p> */}
    
      <SubServiceSectionFinance/>
      <div className='mb-6'>
      <h2 className="text-xl font-semibold mb-6 mx-6">Get Started with Expert Finance Services</h2>
      <p className="text-md text-black mb-6 px-12 text-left">
      Maximize efficiency, enhance security, and drive growth with our tailored Finance Services. Our certified experts provide 24/7 support, proactive monitoring, and strategic Finance planning to meet your business needs.
      </p>
      
      <Link to="/contact"
        className="inline-block bg-[#13689b] text-white py-3 px-6 rounded-md text-md font-semibold transition-transform transform hover:scale-105">
      Contact Us
      </Link>
      </div>
    </section>

  </div>

  </div>
  )
}

export default ConsultancyServices
